import api from "./api";

// Motor de alertas do Hub (épico PO1-2194). Endpoints no backend_hub sob
// /alertas/*. Uma função por endpoint do contrato; todas devolvem `data`.
// Autorização (setor admin, admin do embarcador) é do backend.

// ── Sino e recebidos (A2) ───────────────────────────────────────────────────
// params: { produto?, status?: "todos"|"naoLidos", limite?, pagina? }
export async function listarMinhas(params) {
  const { data } = await api.get("/alertas/minhas", { params: params || {} });
  return data;
}

export async function contarMinhas() {
  const { data } = await api.get("/alertas/minhas/contagem");
  return data;
}

export async function marcarLido(id) {
  const { data } = await api.patch(`/alertas/minhas/${id}/lido`);
  return data;
}

// produto opcional: sem ele marca todos os produtos do usuário.
export async function marcarTodosLidos(produto) {
  const body = produto ? { produto } : {};
  const { data } = await api.post("/alertas/minhas/lidas", body);
  return data;
}

export async function excluirMinha(id) {
  const { data } = await api.delete(`/alertas/minhas/${id}`);
  return data;
}

// ── Inscrições do próprio usuário (A8) ──────────────────────────────────────
export async function listarMinhasInscricoes(produto) {
  const { data } = await api.get("/alertas/inscricoes/minhas", { params: { produto } });
  return data;
}

// Frequência por canal (PO1-3249): { sino, email } = frequência de cada canal
// ou null (desligado). O backend continua aceitando { canal, frequencia }.
export async function salvarMinhaInscricao(idAlerta, { sino, email }) {
  const { data } = await api.put(`/alertas/inscricoes/minhas/${idAlerta}`, {
    sino: sino || null,
    email: email || null,
  });
  return data;
}

export async function removerMinhaInscricao(idAlerta) {
  const { data } = await api.delete(`/alertas/inscricoes/minhas/${idAlerta}`);
  return data;
}

// ── Alerta de teste (A10) ───────────────────────────────────────────────────
export async function enviarTeste({ tarefa, produto }) {
  const { data } = await api.post("/alertas/teste", { tarefa: !!tarefa, produto });
  return data;
}

// ── Tarefas (A7) ────────────────────────────────────────────────────────────
// params: { produto?, status?: "ABERTA"|"CONCLUIDA" }
export async function listarTarefas(params) {
  const { data } = await api.get("/alertas/tarefas", { params: params || {} });
  return data;
}

export async function concluirTarefa(id) {
  const { data } = await api.patch(`/alertas/tarefas/${id}/concluir`);
  return data;
}

// ── Catálogo (A6, admin Everlog) ────────────────────────────────────────────
export async function listarCatalogo() {
  const { data } = await api.get("/alertas/catalogo");
  return data;
}

export async function criarCatalogo(payload) {
  const { data } = await api.post("/alertas/catalogo", payload);
  return data;
}

export async function atualizarCatalogo(id, payload) {
  const { data } = await api.put(`/alertas/catalogo/${id}`, payload);
  return data;
}

// ── Inscrições dos usuários do embarcador (A6, admin do embarcador) ─────────
export async function listarInscricoesEmbarcador(embarcadorId) {
  const { data } = await api.get("/alertas/inscricoes", { params: { embarcadorId } });
  return data;
}

export async function salvarInscricaoUsuario(usuarioId, idAlerta, { embarcadorId, sino, email }) {
  const { data } = await api.put(`/alertas/inscricoes/${usuarioId}/${idAlerta}`, {
    embarcadorId,
    sino: sino || null,
    email: email || null,
  });
  return data;
}

export async function removerInscricaoUsuario(usuarioId, idAlerta, embarcadorId) {
  const { data } = await api.delete(`/alertas/inscricoes/${usuarioId}/${idAlerta}`, {
    params: { embarcadorId },
  });
  return data;
}

// ── PO1-3389: tarefas de fatura do embarcador ──────────────────────────────
// Chave "Usar tarefas de fatura" (parâmetro TarefasFatura do embarcador).
export async function salvarUsoTarefasFatura(embarcadorId, usar) {
  const { data } = await api.put("/alertas/tarefas-fatura", { embarcadorId, usar: !!usar });
  return data;
}

// "Pode ser responsável por fatura" de um usuário do embarcador.
export async function definirResponsavelFatura(usuarioId, embarcadorId, pode) {
  const { data } = await api.put(`/alertas/responsaveis-fatura/${usuarioId}`, { embarcadorId, pode: !!pode });
  return data;
}
